import React from "react";
import { useLanguage } from "../context/LanguageContext";
import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiGlobe,
  FiCalendar,
  FiClock,
  FiVideo,
} from "react-icons/fi";

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="container-custom text-center max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            {t("getInTouch")}
          </h1>
          <p className="text-xl text-gray-700 mb-10">
            {t("contactHeroDescription")}
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Contact Info */}
            <div className="lg:col-span-2">
              <h2 className="text-2xl font-bold mb-6">
                {t("contactInformation")}
              </h2>
              <p className="text-gray-600 mb-8">
                {t("contactTeamDescription")}
              </p>

              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-orange-100 p-3 rounded-lg mr-4">
                    <FiMail className="h-6 w-6 text-orange-500" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">
                      {t("emailUs")}
                    </h3>
                    <p className="text-gray-600">info@solylock.com</p>
                    <p className="text-gray-600">support@solylock.com</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-blue-100 p-3 rounded-lg mr-4">
                    <FiPhone className="h-6 w-6 text-blue-500" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">
                      {t("callUs")}
                    </h3>
                    <p className="text-gray-600">
                      +90 553 331 98 34 - +90 553 089 78 62
                    </p>
                    <p className="text-gray-600">{t("businessHours")}</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-green-100 p-3 rounded-lg mr-4">
                    <FiMapPin className="h-6 w-6 text-green-500" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">
                      {t("visitUs")}
                    </h3>
                    <p className="text-gray-600">
                      Feritpaşa Mah., Teknoloji Cad.
                      <br />
                      42050 Selçuklu/Konya
                      <br />
                      Turkey
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-purple-100 p-3 rounded-lg mr-4">
                    <FiGlobe className="h-6 w-6 text-purple-500" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">
                      {t("ourWebsites")}
                    </h3>
                    <p className="text-gray-600">
                      <a
                        href="https://solylock.dev"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-orange-500"
                      >
                        solylock.dev
                      </a>
                      {" | "}
                      <a
                        href="https://solylock.com"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-orange-500"
                      >
                        solylock.com
                      </a>
                    </p>
                    <p className="text-gray-600">
                      <a
                        href="https://foodapp.solylock.dev"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-orange-500"
                      >
                        {t("demoLink")}: foodapp.solylock.dev
                      </a>
                    </p>
                  </div>
                </div>

                {/* WhatsApp Button */}
                <div className="pt-4">
                  <a
                    href="https://wa.me/905533319834"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-full py-3 px-5 bg-[#25D366] hover:bg-[#22c55e] text-white font-medium rounded-lg transition-all duration-200 shadow-sm"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      className="mr-2.5"
                    >
                      <path
                        fill="currentColor"
                        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                      />
                    </svg>
                    {t("contactViaWhatsApp")}
                  </a>
                </div>
              </div>
            </div>

            {/* Calendar Section */}
            <div className="lg:col-span-3">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="p-6 border-b border-gray-100">
                  <h2 className="text-2xl font-bold mb-2">
                    {t("bookAppointment") || "Book an Appointment"}
                  </h2>
                  <p className="text-gray-600">
                    {t("scheduleDescription") ||
                      "Schedule a meeting with our team to discuss your project."}
                  </p>
                </div>

                {/* Meeting Type Buttons */}
                <div className="p-6 bg-gray-50">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <a
                      href="https://calendar.app.google/GCLQcvn6cB3NWfap9"
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center p-4 bg-white hover:bg-orange-50 border-2 border-orange-500 rounded-lg text-orange-600 font-medium transition-all duration-200 shadow-sm group"
                    >
                      <div className="flex-shrink-0 bg-orange-100 p-3 rounded-full mr-3 group-hover:bg-orange-200 transition-all">
                        <FiVideo className="h-5 w-5 text-orange-600" />
                      </div>
                      <div className="text-left">
                        <p className="font-semibold">
                          {t("videoConsultation") || "Video Consultation"}
                        </p>
                        <p className="text-sm text-gray-500">
                          {t("minutes30") || "30 minutes"}
                        </p>
                      </div>
                    </a>

                    <a
                      href="https://calendar.app.google/GCLQcvn6cB3NWfap9"
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center p-4 bg-white hover:bg-blue-50 border-2 border-blue-500 rounded-lg text-blue-600 font-medium transition-all duration-200 shadow-sm group"
                    >
                      <div className="flex-shrink-0 bg-blue-100 p-3 rounded-full mr-3 group-hover:bg-blue-200 transition-all">
                        <FiClock className="h-5 w-5 text-blue-600" />
                      </div>
                      <div className="text-left">
                        <p className="font-semibold">
                          {t("demoSession") || "Product Demo"}
                        </p>
                        <p className="text-sm text-gray-500">
                          {t("minutes45") || "45 minutes"}
                        </p>
                      </div>
                    </a>
                  </div>
                </div>

                {/* Calendar Iframe */}
                <div className="w-full h-[550px] border-t border-gray-100">
                  <iframe
                    title="Appointment Calendar"
                    src="https://calendar.app.google/GCLQcvn6cB3NWfap9"
                    style={{ border: 0, width: "100%", height: "100%" }}
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="section bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">{t("findUs")}</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t("visitOurOffice")}
            </p>
          </div>
          <div className="rounded-xl overflow-hidden shadow-lg">
            {/* We'll use an iframe for Google Maps here */}
            <div style={{ width: "100%", height: "450px" }}>
              <iframe
                title="ByteBelly Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835253616446!2d32.4892743!3d37.9151305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d08560eedf1e45%3A0x6b2d49cb9d623740!2sTeknokent!5e0!3m2!1sen!2str!4v1621536456788!5m2!1sen!2str"
                style={{ border: 0, width: "100%", height: "100%" }}
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
